import { render, staticRenderFns } from "./SearchResultContactsList.vue?vue&type=template&id=2d6a5a3e&"
import script from "./SearchResultContactsList.vue?vue&type=script&lang=js&"
export * from "./SearchResultContactsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6a5a3e')) {
      api.createRecord('2d6a5a3e', component.options)
    } else {
      api.reload('2d6a5a3e', component.options)
    }
    module.hot.accept("./SearchResultContactsList.vue?vue&type=template&id=2d6a5a3e&", function () {
      api.rerender('2d6a5a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/SearchResultContactsList.vue"
export default component.exports